import '../Inscription.less';
import {Avatar, Menu, Dropdown, Tooltip,Icon} from 'antd';
import { ApartmentOutlined,EyeOutlined, HomeOutlined,FileTextOutlined, TeamOutlined, UserOutlined, LogoutOutlined,UnorderedListOutlined } from '@ant-design/icons';
import React, { Component } from "react";
import cabezal from '../Cabezal.jpg'
import {NavLink} from "react-router-dom";
import windowSize from 'react-window-size'

import {logout,centerStyle} from './utils';

/** *
* *Menu used in all Admin Views, the only variable is the reports menu, that receives as a param
*/
class Link extends React.Component{
  constructor(props) {
      super(props);
  }
  navigate(history, to, onNavigate) {
    var toPart;
    var state = {};
    if (typeof to === 'object') {
        const navObj = to ;
        toPart = navObj.pathname;
        state = navObj.state || {};
    } else {
        toPart = to;
    }

    if (onNavigate)
        onNavigate(toPart);
    const getLocation = function (href) {
        var l = document.createElement("a");
        l.href = href;
        return l;
    };

    
}

   loadPage() {
      this.props.busyContext.setIsBusy(true);
      this.navigate(this.props.history, this.props.to, url => {
          this.props.busyContext.setIsBusy(false);
          if (this.props.onNavigate) {
              this.props.onNavigate(url);
          }
      });
  }

  render() {
      return <a style={{display: 'inline-block'}} onClick={this.loadPage}>{this.props.children}</a>
  }
  
}
function WrapInDropdown(props) {
  if (props.subMenu) {
    return <Dropdown overlay={props.subMenu} trigger={['click']}>
      {(() => {
        if (props.to) {
          return <Link to={props.to || ''} className="ant-dropdown-link" style={{ height: 44 }}>
            {props.children}
          </Link>
        }
        return <div className="ant-dropdown-link" style={{ height: 44 }}>{props.children}</div>;
      })()}
    </Dropdown>
  }

  if (props.to) {
    if (props.target)
      return <a href={props.to || ''} target={props.target} >
        {props.children}
      </a>
    return <Link to={props.to}>{props.children}</Link>
  }
  return props.children;
}

  class NavItemClass extends React.Component {
   render() {
      var width = (this.props).windowWidth;
      var isMobileOrTable = width < 768;
      let icon = undefined;
      let title = undefined;
      let iconOnly = this.props.iconOnly && !isMobileOrTable;
      if (this.props.icon) {
          icon = this.props.icon
      }
      if (typeof this.props.title === 'string') {
        title = <span>{this.props.title}</span>
      } else {
        title = this.props.title
      }
      if (this.props.subMenu && isMobileOrTable) {
        return <div className='navbar-items'>
          <div className={`navbar-item${this.props.selected ? ' selected' : ''}`}>
            {icon && <div style={{ float: 'left' }}>
              <Tooltip title={iconOnly && typeof this.props.title === 'string' ? this.props.title : ''} placement='bottom'>
                {icon}
              </Tooltip>
            </div>}
            {!iconOnly && title}
          </div>
          {this.props.subMenu}
        </div>
      }
      return <div className={`navbar-item${this.props.selected ? ' selected' : ''}`}>
        <WrapInDropdown subMenu={this.props.subMenu} to={this.props.to} target={this.props.target}>
          {icon && <div style={{ float: 'left' }}>
            <Tooltip title={iconOnly && typeof this.props.title === 'string' ? this.props.title : ''} placement='bottom'>
              {icon}
            </Tooltip>
          </div>}
          {!iconOnly && title}
        </WrapInDropdown>
      </div>
    }
  }
  export const NavItem = windowSize(NavItemClass);

